import React from 'react';

import { Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@material-ui/core';

import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';

import styles from './AssetPrefixesTable.module.scss';

const AssetPrefixesTable = ({ currentConfiguration }) => {
  return (
    <TableContainer className={styles.tableContainer} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell className={styles.firstRow}>Prefix</StyledTableCell>
            <StyledTableCell className={styles.lastRow}>Quantity</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentConfiguration?.assetPrefixes?.length ? (
            currentConfiguration.assetPrefixes.map((row) => (
              <StyledTableRow key={row.id}>
                <StyledTableCell>{row.prefix}</StyledTableCell>
                <StyledTableCell align="left">
                  <span>{row.quantity || 0}</span>
                </StyledTableCell>
              </StyledTableRow>
            ))
          ) : (
            <StyledTableRow>
              <StyledTableCell colSpan={2} className={styles.emptyTable}>
                No available data in the table.
              </StyledTableCell>
            </StyledTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AssetPrefixesTable;
